module.exports = __webpack_public_path__ + "static/img/alipay.c12dc77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pay/alipay.png
// module id = tuCX
// module chunks = 1